export enum IntegrationEntitySyncStatusEnum {
  SYNCED = "SYNCED",
  NOT_SYNCED = "NOT_SYNCED",
  SUGGESTED_SYNC = "SUGGESTED_SYNC",
}
